export default "__VITE_ASSET__07af6de8__"